export const REDUCER_NAME = 'dashboards';
